import { isMobile } from './utils'
import Cookies from 'js-cookie'

$(() => {

	// Underline style

	$('.underline').each(function() {

		var words = $(this).text().split(' ')

		$(this).empty().html(function() {

	    var i = 0

			for (i = 0; i < words.length; i++) {
				if (i == 0) {
					$(this).append('<span>' + words[i] + '</span>')
				} else {
					$(this).append(' <span>' + words[i] + '</span>')
				}
			}
		})
	})

	if (isMobile.any()) {
		// Close collapsible main-menu after click
		$('#main-menu > ul > li > a').on('click', () => $('#main-menu-collapse-button').click())
	}

	// About page scroller

	// if ($('body').hasClass('about')) {
	//
	// 	// Skrollr
	// 	var skroll = skrollr.init({
	// 		forceHeight: false
	// 	})
	//
	// 	// Skrollr menu
	// 	skrollr.menu.init(skroll, {
	// 			animate: true,
	// 			easing: 'swing',
	// 			scale: 2,
	// 			duration: function(currentTop, targetTop) {
	// 					Math.abs(targetTop - currentTop) / 4;
	// 			}
	// 	})
	//
	// 	onWindowResize()
	// 	$(window).resize(onWindowResize)
	// }
	//
	// function onWindowResize () {
	// 	skroll.refresh()
	// }

  // Public vote on project

  function csrfSafeMethod(method) {
    return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method));
  }

  $.ajaxSetup({
    beforeSend: function(xhr, settings) {
      if (!csrfSafeMethod(settings.type) && !this.crossDomain) {
        xhr.setRequestHeader("X-CSRFToken", Cookies.get('csrftoken'));
      }
    }
  });

  $('.public-vote').on('click', function () {
       $.ajax({
               url: './vote/',
               method: 'POST',
       })
               $(this).text('Thanks for your vote!').addClass('voted');
               $(this).off();
  })
})

// Sticky elements

// On homepage

var fixedSidebarTopOffset = -85
var fixedSidebarBottomOffset = 15

var controller = new ScrollMagic.Controller()

var scene1 = new ScrollMagic.Scene({
	triggerElement: '#section__label--latest',
	triggerHook: 'onLeave',
	offset: fixedSidebarTopOffset,
	duration: $('#section-latest').height() -
		$('#section__label--latest').height() -
		fixedSidebarBottomOffset
})

scene1.setClassToggle('#section__label--latest', 'fixed')
	.setPin('#section__label--latest')
	.addTo(controller)

var scene2 = new ScrollMagic.Scene({
	triggerElement: '#section__label--news',
	triggerHook: 'onLeave',
	offset: fixedSidebarTopOffset,
	duration: $('#section-news').height() -
		$('#section__label--news').height() -
		fixedSidebarBottomOffset
})

scene2.setClassToggle('#section__label--news', 'fixed')
	.setPin('#section__label--news')
	.addTo(controller)

var scene3 = new ScrollMagic.Scene({
	triggerElement: '#section__label--events',
	triggerHook: 'onLeave',
	offset: fixedSidebarTopOffset,
	duration: $('#section-events').height() -
		$('#section__label--events').height() -
		fixedSidebarBottomOffset
})

scene3.setClassToggle('#section__label--events', 'fixed')
	.setPin('#section__label--events')
	.addTo(controller)

var scene4 = new ScrollMagic.Scene({
	triggerElement: '#section__label--ideas',
	triggerHook: 'onLeave',
	offset: fixedSidebarTopOffset,
	duration: $('#section-ideas').height() -
		$('#section__label--ideas').height() -
		fixedSidebarBottomOffset
})

scene4.setClassToggle('#section__label--ideas', 'fixed')
	.setPin('#section__label--ideas')
	.addTo(controller)


var scene4 = new ScrollMagic.Scene({
	triggerElement: '#section__label--video',
	triggerHook: 'onLeave',
	offset: fixedSidebarTopOffset,
	duration: $('#section-video').height() -
		$('#section__label--video').height() -
		fixedSidebarBottomOffset
})

scene4.setClassToggle('#section__label--video', 'fixed')
	.setPin('#section__label--video')
	.addTo(controller)


var scene5 = new ScrollMagic.Scene({
	triggerElement: '#section__label--open-call',
	triggerHook: 'onLeave',
	offset: fixedSidebarTopOffset,
	duration: $('#section-open-call').height() -
		$('#section__label--open-call').height() -
		fixedSidebarBottomOffset
})

scene5.setClassToggle('#section__label--open-call', 'fixed')
	.setPin('#section__label--open-call')
	.addTo(controller)


// On inside pages

var scene = new ScrollMagic.Scene({
	triggerElement: '#pined-sidebar',
	triggerHook: 'onLeave',
	offset: fixedSidebarTopOffset + 5,
	duration: $('#with-pined-sidebar').height() -
		$('#pined-sidebar').height() -
		fixedSidebarBottomOffset
})

scene.setClassToggle('#pined-sidebar', 'fixed')
	.setPin('#pined-sidebar')
	.addTo(controller)


// Slide search
$('.search-toggler').click(function() {
  $('#searchSlide').toggleClass('search-slide-open');
  $(this).toggleClass('search-toggler--close');
});
